import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import BiospecimenHero from "./BiospecimenHero";
import ImageCarousel from "./ImageCarousel";
import ContactSection from "../../components/common/ContactSection";
import ProcurementOptions from "../../components/common/ProcurementOptions";
import { Check } from "lucide-react";
import SourcingSection from "./SourcingSection";

const CustomizedServiceDetail = () => {
  const [expandedItems, setExpandedItems] = useState({});

  const toggleExpanded = (index) => {
    setExpandedItems((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  const customData2 = [
    {
      title: "Prospective Collections:",
      description:
        "Fresh specimens collected specifically for your study timeline",
    },
    {
      title: "Rare Cohorts:",
      description:
        "Hard-to-find patient populations and uncommon disease states",
    },
    {
      title: "Matched Specimen Sets:",
      description:
        "Tumor/normal pairs, pre/post-treatment series, longitudinal collections",
    },
    {
      title: "Protocol-Based Handling",
      description:
        "Custom processing, aliquoting, and storage per your specifications",
    },
    {
      title: "Multi-Matrix Collections:",
      description: "Multiple specimen types from the same subjects",
    },
    {
      title: "Custom Data Capture:",
      description:
        "Specific clinical annotations, questionnaires, outcome tracking",
    },
  ];
  return (
    <>
      <Helmet>
        <title>ANVIYA Biospecimen Services</title>
      </Helmet>

      <main className="w-full bg-white">
        <Header />

        <BiospecimenHero />
        <ImageCarousel />
        <ProcurementOptions
          title="What We Can Deliver"
          descriptionTitle="Every ANVIYA biospecimen meets stringent quality and ethical standards:"
          options={customData2}
          icon={Check} // Optional: Changes the icon for all cards
        />
        <SourcingSection />
        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default CustomizedServiceDetail;
